import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box, IconButton, Stack, Button, Tooltip } from '@mui/material';
import { ADD_TO_GPT_SANDBOX, TICKET_DETAILS_LOADING } from '../../redux/actions/authActions.js';
import AddCommentOutlinedIcon from '@mui/icons-material/AddCommentOutlined';
import { convertMarkdownToHtml } from '../../constants/utils.js';
import GPTSandbox from '../../pages/agentassist/GPTSandbox.jsx';
import { insertTextToTicket, updateEvent } from '../../api.js';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import React, { useState } from 'react';
import Markdown from 'markdown-to-jsx';


const GptSandboxDialog = ({ open, onClose, renderType, content, loading, ticketingSystem, subDomain, userEmail, orgId, ticketDetails, prismToken }) => {
    const [gptSandboxEditable, setGptSandboxEditable] = useState(false);
    const ticketId = useSelector((state) => state.ticket.ticketId);
    const agentDetails = useSelector((state) => state.auth.agentDetails);
    const email = useSelector((state) => state.auth.email);
    const ticketDataloading = useSelector((state) => state.ticket.ticketDetailsLoading);
    const isTicketIdValid = ticketId;
    const dispatch = useDispatch();
    const handleDialogClose = () => {
        setGptSandboxEditable(false);
        onClose();
    }
    const insertContentIntoTicket = () => {
        dispatch({ type: TICKET_DETAILS_LOADING, payload: true })
        dispatch((updateEvent(`${renderType}Insert`, "", ticketDetails?.id, content, userEmail, orgId, prismToken)))
        dispatch(insertTextToTicket(convertMarkdownToHtml(content), ticketingSystem, subDomain, userEmail, orgId, ticketDetails, prismToken))
    }
    return (
        <Dialog fullWidth maxWidth="md" open={open} onClose={handleDialogClose} scroll="paper">
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
                <Typography variant="h6" fontWeight={600}>
                    GPT Sandbox
                </Typography>
                <IconButton onClick={handleDialogClose} edge="end">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Box>
                    {
                        gptSandboxEditable ?
                            <GPTSandbox isTicketIdValid={isTicketIdValid} agentDetails={agentDetails} userEmail={email} dialogViewSandbox={true} />
                            :
                            <Markdown>{content}</Markdown>
                    }
                </Box>
            </DialogContent>
            {!gptSandboxEditable &&
                <DialogActions>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-end">
                        <Tooltip title="Edit In GPT Sandbox" placement="top" arrow>
                            <Button disabled={ticketDataloading} variant="outlined" startIcon={<EditOutlinedIcon />} onClick={() => {
                                dispatch({
                                    type: ADD_TO_GPT_SANDBOX,
                                    payload: {
                                        action: "append",
                                        content: convertMarkdownToHtml(content),
                                    }
                                });
                                setGptSandboxEditable(true);
                            }}>
                                Edit
                            </Button>
                        </Tooltip>
                        <Tooltip title={`Insert Content In Ticket #${ticketId}`} placement="top" arrow>
                            <Button disabled={ticketDataloading} loading={ticketDataloading} loadingPosition="end" variant="contained" startIcon={<AddCommentOutlinedIcon />} onClick={insertContentIntoTicket}>
                                Insert
                            </Button>
                        </Tooltip>
                    </Stack>
                </DialogActions>
            }
        </Dialog>
    );
};

export default GptSandboxDialog;
